import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { payout } from "../../rbac-consts";
import { default as SuperAdminTransactionDetailsContainer } from "./superAdmin/TransactionDetailsContainer";

const TransactionDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={payout.SUPER_ADMIN}
        yes={() => (
          <SuperAdminTransactionDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default TransactionDetailsWrapper;